import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=aeb28a3c&scoped=true&"
import script from "./Fail.vue?vue&type=script&lang=ts&"
export * from "./Fail.vue?vue&type=script&lang=ts&"
import style0 from "./Fail.vue?vue&type=style&index=0&id=aeb28a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb28a3c",
  null
  
)

export default component.exports